import { AxiosResponse } from "axios";
import { CalculoCuotaRequest } from "../hooks/useTablasDesarrollo";
import axiosInstance from "../../../interceptors/axiosInstance";

const getCuota = async (calculoCuotaRequest: CalculoCuotaRequest) => {
    const response: AxiosResponse = await axiosInstance.get(`siscred-api-mutuo/v1/tablas-desarrollo/calcular-cuota`, {
        params: {
            TablaDesarrolloId: calculoCuotaRequest.TablaDesarrolloId,
            MontoCredito: calculoCuotaRequest.MontoCredito
        },
        headers: {
            'X-Hide-Loader': 'true'
        }
    });
    return response;
};

export {
    getCuota
}